import { render, staticRenderFns } from "./ActivityCard.vue?vue&type=template&id=6ddf70f5&scoped=true"
import script from "./ActivityCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ActivityCard.vue?vue&type=style&index=0&id=6ddf70f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf70f5",
  null
  
)

export default component.exports